import { http, HttpResponse } from 'msw'

interface IFinanceSettings {
  budgetOvertureToggle: boolean
}

const defaultFinanceSettings: IFinanceSettings = {
  budgetOvertureToggle: false,
}

export const mockGetFinanceSettings = (
  settings: Partial<IFinanceSettings> = {}
) => {
  return http.get(
    `/api/v3/settings/company/finance/`,
    () => {
      return HttpResponse.json(
        {
          data: {
            ...defaultFinanceSettings,
            ...settings,
          },
        },
        { status: 200 }
      )
    },
    { once: true }
  )
}
